import styled from '@emotion/styled';
import { selectSelectedCountry } from 'store/country/countrySlice';
import { useAppSelector } from 'store';

import { Divider, ExternalLink } from '@britishcouncil/react-solas-ors3';

const LinksList = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const Links = () => {
  const selectedCountry = useAppSelector(selectSelectedCountry);

  if (!selectedCountry) return null;

  return (
    <>
      <Divider />
      <LinksList>
        <ExternalLink href={selectedCountry.urlFindOutMoreAboutExamFees}>Find out more about exam fees</ExternalLink>
        <ExternalLink href={selectedCountry.urlHowDoIPay}>How do I pay?</ExternalLink>
        <ExternalLink href={selectedCountry.urlLearnAboutCancellationsAndRefunds}>
          Learn about cancellations and refunds
        </ExternalLink>
        <ExternalLink href={selectedCountry.urlNeedHelp}>Need help?</ExternalLink>
      </LinksList>
    </>
  );
};

export default Links;
